import { useContext } from "react";
import ModalsContext from "./ModalsContext";
var useModals = function () {
    var _a = useContext(ModalsContext), openModal = _a.openModal, closeModal = _a.closeModal;
    return { openModal: openModal, closeModal: closeModal };
};
export default useModals;
//# sourceMappingURL=useModals.js.map